<!-- Patient Identification Labels -->
<div *ngIf="patientName !== '...' && patient"
     class="patient-identification-labels patient-identification-labels-container fx-row fx-col-xs fx-jc-between fx-ai-center fx-jc-start-xs fx-ai-start-xs fx-gap-20 fx-gap-12-xs"  >

  <!-- Patient Info Container -->
  <div class="patient-info-container fx-row fx-col-xs fx-gap-16 fx-gap-8-xs"  >

    <!-- Patient ID Label -->
    <app-patient-id-display [patient]="patient" [userOwnerID]="userOwnerID"></app-patient-id-display>

    <!-- Date of Birth Label -->
    <div class="dob-label dob-label-container">
      <span class="dob-label-text">
        DOB - {{ patient.dob | date:'M/d/yyyy' }}
      </span>
    </div>

    <!-- Gender Label -->
    <div *ngIf="patient?.gender"
         class="gender-label gender-label-container">
      <span class="gender-label-text">
        Gender - {{ patient.gender }}
      </span>
    </div>
  </div>

  <!-- Additional Patient Info (if needed) -->
  <div class="additional-patient-info additional-patient-info-container fx-row fx-row-xs fx-jc-end fx-ai-center fx-jc-start-xs fx-ai-center-xs fx-gap-12"  >
    <!-- Placeholder for future patient info elements -->
  </div>
</div>

